
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Right = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <polygon points="10 19 9 18 14.4 12.5 9 7 10 6 16.6 12.5 10 19"></polygon>
        </g>
      </g>
    </IconBase>);
};

Right.defaultProps = {
  title: 'Right',
};

export default Right;
